 import React from "react";
 import CreateModelHeader from "./components/CreateModelHeader";
 import CreateModelProgress from "./components/CreateModelProgress";
 import { useNavigate } from "react-router-dom";
import Vector from "../../assets/Vector.svg"
import { useState } from "react";
import FormikControl from "../../components/signUpForm/ReusableFormik/FormikControl";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ModelContext } from "./DataContext";
import { useContext } from "react";

 const CreateModelStep3 = ()=>{

    const navigate = useNavigate();
    const {saveModelData} = useContext(ModelContext);
    

    // const formik = useFormik({
    //     initialValues: {
    //       value1: " ",
    //       score1:  " ",
    //       value2:  " ",
    //       score2:  " "

    //     }, validate: (values) => {
    //         const errors = {};       
    //         if(!values.value1){
    //             errors.value1 = "Value required";
    //         }
    //         if(!values.value2){
    //             errors.value2 = "Value required";
    //         }
    //         if(!values.score1){
    //             errors.score1 = "Score required";
    //         }
    //         if(!values.score2){
        
    //             errors.score2 = "score required";
    //         }                         
    //         return errors;
    //     },
    //     onSubmit: (values) =>{      
    //         navigate('/CreateModelStep4')    
    //     }
    // })

    // const handleInputChangeValue1= (event) =>{
    //     setValue1(event.target.value);
    // }

    // const handleInputChangeValue2= (event) =>{
    //     setValue2(event.target.value);
    // }

    // const handleInputChangeScore1= (event) =>{
    //     setassignScore1(event.target.value);
    // }

    // const handleInputChangeScore2= (event) =>{
    //     setassignScore2(event.target.value);
    // }


    //     navigate('/CreateModelStep4')
    

    // const options = [
    //     { value: 'option1', label: 'Admin' },
    //     { value: 'option2', label: 'Analyst' },
    // ];

    // const handleSelectOption = (options) => {
    //     setSelectedOption5(options.label);
    // };

    // const handleSelectOption1 = (options) => {
    //     setSelectedOption6(options.label);
    // };

    const variable1 = [
        { value: '', key: 'Select' },
           { value: 'Total credit account', key: 'Total credit account' },
           { value: 'Total lost', key: 'Total lost' },
           { value: 'Total doubtful', key: 'Total doubtful' },
           { value: 'Total watchlisted', key: 'Total watchlisted' },
           { value: 'Total substandard', key: 'Total substandard' },
           { value: 'Total dishonored cheque', key: 'Total dishonored cheque' },
           { value: 'Total outstanding loan', key: 'Total outstanding loan' },
           { value: 'Highest loan amount', key: 'Highest loan amount' },
           { value: 'Total overdue loan', key: 'Total overdue loan' },
       ];
    
       const Operator1 = [
            { value: '', key: 'Select' },
           { value: 'Less than', key: 'Less than' },
           { value: 'Less than or equal to' , key: 'Less than or equal to' },
           { value: 'Greater than', key: 'Greater than' },
           { value: 'Greater than or equal to', key: 'Greater than or equal to' },
           { value: 'Equal to', key: 'Equal to' },
       ];

       const validationSchema = Yup.object({
        variable1: Yup.string().required("Required"),
        variable2: Yup.string().required("Required"),
        operator1: Yup.string().required("Required"),
        operator2: Yup.string().required("Required"),
        value1: Yup.number().typeError('Must be a number').required("Required"),
        value2: Yup.number().typeError('Must be a number').required("Required"),
        score1: Yup.number().typeError('Must be a number').required("Required"),
        score2: Yup.number().typeError('Must be a number').required("Required"),
    });

    const initialValues = {
        variable1: "",
        variable2: "",
        operator1: "",
        operator2: "",
        value1: "",
        value2: "",
        score1: "",
        score2: "",
    } 

    const onSubmit = (values) => {
        saveModelData(values);
        navigate("/CreateModelStep4");
    };

    return(
        <div>
            <div>
                <CreateModelHeader/>
            </div>
            <div>
                <CreateModelProgress title={'Create Predition Model'} indexActualPage={3}/>
            </div>

            <div className="flex justify-center"> 
                    {/* className="mt-5 flex flex-col items-center justify-center bg-red-100" */}
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {(formik) => {
                            return (
                                <Form className="">  
                                <div className="flex xl:flex-row md:flex-row sm:flex-col sm:items-center xl:justify-center">                             
                                    <div className="flex">
                                        <div className="flex flex-col">
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] mr-4">
                                                <FormikControl
                                                    control="select"
                                                    label="Variable"
                                                    // type="text"
                                                    name="variable1"
                                                    options={variable1}
                                                />
                                            </div>
                                            
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] mr-4">
                                                <FormikControl
                                                    control="select"
                                                    label=""
                                                    // type="text"
                                                    name="variable2"
                                                    options={variable1}
                                                />
                                            </div>
                                            
                                        </div>

                                        <div className="flex flex-col">
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] mr-4">
                                                <FormikControl
                                                    control="select"
                                                    label="Operator"
                                                    // type="text"
                                                    name="operator1"
                                                    options={Operator1}
                                                />
                                            </div>
                                            
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] mr-4">
                                                <FormikControl
                                                    control="select"
                                                    label=""
                                                    // type="text"
                                                    name="operator2"
                                                    options={Operator1}
                                                />
                                            </div>
                                            
                                        </div>
                                    </div>

                                    <div className="flex">
                                        <div className="flex flex-col sm:-ml-4 xl:pl-3 md:pl-2">
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] mr-4 flex justify-start mt-1">
                                                <img src={Vector} alt="Moeda" className="mr-1 mt-16" />  
                                                <FormikControl
                                                    control="input"
                                                    label="Value"
                                                    type="text"
                                                    name="value1"
                                            
                                                />
                                            </div>
                                            
                                            <div className="flex xl:w-[265px] md:w-[190px] sm:w-[230px] mr-4 -mt-3">
                                                <img src={Vector} alt="Moeda" className="mr-1 mt-3" />  
                                                <FormikControl
                                                    control="input"
                                                    label=""
                                                    type="text"
                                                    name="value2"
                                                    // className="-mt-10 w-full px-4 py-2 pr-10 text-xs md:text-sm rounded-md bg-white shadow-md border-border-input placeholder-gray-500" 
                                                />
                                            </div>
                                            
                                        </div>

                                        <div className="flex flex-col">
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] mt-1">
                                                <FormikControl
                                                    control="input"
                                                    label="Assigned Score"
                                                    type="text"
                                                    name="score1"
                                            
                                                />
                                            </div>
                                            
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] -mt-2">
                                                <FormikControl
                                                    control="input"
                                                    label=""
                                                    type="text"
                                                    name="score2" 
                                                    // className="-mt-2 w-full px-4 py-2 pr-10 text-xs md:text-sm rounded-md bg-white shadow-md border-border-input placeholder-gray-500"                                      
                                                />
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>    
                                    <span className="flex justify-center mt-20 mb-20">
                                        <button     
                                            type="submit" 
                                            className='bg-indigo-500 hover:bg-indigo-600 text-slate-50 border rounded-md xl:px-5 md:px-2 lg:px-3 xl:py-2 md:w-28 xl:w-[150px] xl:h-[56px] sm:w-28 sm:h-12 sm;text-xs' 
                                            disabled={!formik.isValid}>
                                            Continue
                                        </button>
                                    </span>
                                   
                                </Form>
                            );
                        }}
                    </Formik>  
                </div> 
            </div>
    )

 }

 export default CreateModelStep3;
            {/* <form onSubmit={formik.handleSubmit}>
                <div className="mt-3 xl:flex-row md:flex-row flex justify-center sm:items-center sm:flex-col">
                    <div className="flex">
                    <div className="flex flex-col mr-4">
                        <div className="xl:w-[265px] md:w-[190px] sm:w-[230px]">
                            <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="dropdown2">Variable</label>
                            <CustomSelect 
                                id={"dropdown3"}
                                options={options}
                                onSelect={handleSelectOption}
                            />
                        </div>
                    
                        <div className="mt-5 xl:w-[265px] md:w-[190px] sm:w-[230px]">
                            <CustomSelect 
                                id={"dropdown3"}
                                options={options}
                                onSelect={handleSelectOption1}
                            />
                        </div>
                
                    </div>
                    <div className="flex flex-col mr-4">
                    
                        <div className="xl:w-[265px] md:w-[190px] sm:w-[230px]">
                            <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="dropdown2">Operator</label>
                            <CustomSelect 
                                id={"dropdown4"}
                                options={options}
                                onSelect={handleSelectOption}
                            />
                        </div>
                    
                        <div className="mt-5 xl:w-[265px] md:w-[190px] sm:w-[230px]">
                            <CustomSelect 
                                id={"dropdown4"}
                                options={options}
                                onSelect={handleSelectOption1}
                            />
                        </div>

                    </div> 
                    </div>  

                    <div className="flex">
                    <div>
                        <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="value1">Value</label>
                        <div className="flex flex-col mr-4">                           
                            <div className="flex xl:w-[265px] md:w-[190px] sm:w-[230px]">
                                <img src={Vector} alt="Moeda" className="mr-1 mb-10" />   
                                <CustomInput
                                    id={"value1"}
                                    name = {"value1"}
                                    type={'text'}
                                    value={formik.values.value1}
                                    placeholder=''
                                    onChangeInput={handleInputChangeValue1}
                                    formik={formik}
                                />
                            </div>  
                            {formik.errors.value1 && formik.touched.value1 ?
                                    <span className="text-red-500 text-xs mt-1">{formik.errors.value1}</span> : 
                                    <span className="text-red-500 text-xs mt-1">{"  "}</span>
                            }

                            <div className="flex mt-5 xl:w-[265px] md:w-[190px] sm:w-[230px]">
                                <img src={Vector} alt="Moeda" className="mr-1" />   
                                    
                                <CustomInput
                                    id={"value1"}
                                    name = {"value2"}
                                    type={'text'}
                                    value={formik.values.value2}
                                    placeholder=''
                                    onChangeInput={handleInputChangeValue2}
                                    formik={formik}
                                /> 
                            </div> 
                            {formik.errors.value2 && formik.touched.value2 ?
                                    <span className="text-red-500 text-xs mt-1">{formik.errors.value2}</span> : <span className="text-red-500 text-xs mt-1">{"  "}</span>
                            }                                           
                        </div>
                    </div>
                    
                    <div>
                        <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="score1">Assigned Score</label>
                        <div className="flex flex-col mr-4 xl:w-[265px] md:w-[190px] sm:w-[230px]">   
                            <div className="">
                                <CustomInput
                                    id={"score1"}
                                    name={"score1"}
                                    type={'text'}
                                    value={formik.values.score1}
                                    placeholder=''
                                    className={""}
                                    onChangeInput={handleInputChangeScore1}
                                    formik={formik}
                                />
                            </div>                        
                           
                             {formik.errors.score1 && formik.touched.score1 ?
                                    <span className="text-red-500 text-xs mt-1">{formik.errors.score1}</span> :
                                     <span className="text-red-500 text-xs mt-1">{"  "}</span>
                        }
                            <div className="mt-5"> 
                                {/* className={`mt-5` ${formik.errors.score1 ? "mt-3}
                                <CustomInput
                                    id = {"score1"}
                                    name={"score2"}
                                    type={'text'}
                                    value={formik.values.score2}
                                    placeholder=''
                                    className={""}                              
                                    onChangeInput={handleInputChangeScore2}
                                    formik={formik}
                                /> 
                            </div>  
                           
                             {formik.errors.score2 && formik.touched.score2 ?
                                    <span className="text-red-500 text-xs mt-1">{formik.errors.score2}</span> : <span  className="text-red-500 text-xs mt-1">{"  "}</span>
                        }
                    </div>
                </div>
            </div>
            </div>
                    <button type="submit"
                    className="bg-enabled-btn text-slate-50 border rounded cursor-pointer my-7 py-2 px-8" onClick={onsubmit}
                    >
                        Continue
                    </button>
             </form> */}
   